<template>
  <div
    v-if="unreadNotifications.length > 0"
  >
    <table>
      <tbody>
        <tr v-for="(notification, i) in displayNotifications" :key="i"
          :class="{ 'border-b': i !== (displayNotifications.length - 1) }"
          @click="markAsRead(notification)">
          <td class="py-3">
            <div class="leading-normal font-medium">
              {{ notification.data.subject }}
            </div>
            <div class="leading-tight text-sm">
              {{ notification.data.description }}
            </div>
          </td>
          <td class="text-tertiary hover:text-black cursor-pointer p-3 text-center" @click.stop="cta(notification)">
            <div class="flex flex-col items-center justify-center ">
              <div :class="{ 'text-tertiary': notification.read_at === null }">
                <icon class="w-8 h-8 lg:w-10 lg:h-10 mx-auto" :name="notification.data.call_to_action_icon" :center="false" />
              </div>
              <span class="text-xs leading-none" v-if="notification.data.call_to_action_text">
                {{ notification.data.call_to_action_text }}
              </span>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <div v-else class="flex-1 text-3xl text-grey-light flex items-center justify-center">
    You're all caught up
  </div>
</template>

<script>
import api from '@/http'
import { mapState } from 'vuex'
import { get, find } from 'lodash'

export default {
  props: {
    limit: {
      type: Number,
      default: 3
    }
  },

  computed: {
    ...mapState(['profile']),

    notifications () {
      return get(this.profile, 'notifications', [])
    },

    unreadNotifications () {
      return this.notifications.filter(n => n.read_at === null)
    },

    displayNotifications () {
      return this.unreadNotifications.slice(0, this.limit)
    },

    undisplayedNotifications () {
      return this.notifications.slice(this.limit).filter(n => n.read_at === null)
    }
  },

  methods: {
    markAsRead (notification) {
      if (notification.read_at === null) {
        api.post('/notification/read', notification)
          .then(({ data }) => {
            let index = this.notifications.indexOf(
              find(this.notifications, (n) => n.id === data.id)
            )

            if (index >= 0) {
              this.notifications.splice(index, 1, data)
            }
          })
      }
    },

    cta (notification) {
      this.markAsRead(notification)

      let link = notification.data.call_to_action_link
      if (link.startsWith('http')) {
        let tab = window.open()
        tab.location.href = link
        return
      }
      this.$router.replace(link)
    }
  }
}
</script>
